import { useState } from 'react';

import { ContributionPaymentMethod } from '../contribution.types';

export const useContributionPaymentMethod = () => {
  const [paymentMethod, setPaymentMethod] = useState<ContributionPaymentMethod>({});
  const [paymentMethodSetup, setPaymentMethodSetup] = useState(false);
  const [isPaymentMethodValid, setIsPaymentMethodValid] = useState(false);

  return {
    paymentMethod,
    setPaymentMethod,
    paymentMethodSetup,
    setPaymentMethodSetup,
    isPaymentMethodValid,
    setIsPaymentMethodValid,
  };
};
